export const fotoyuId = 'pVdPJrOWmn72KqkZNkavbegDy6Ml89x3'
